import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isEmpty, isNil} from 'ramda';

import {useGetSupplierDiscountGroupQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {usePermissions} from '@dms/shared';

import {SupplierDiscountGroupDetailForm} from './components/SupplierDiscountGroupDetailForm';

export function WarehousesSupplierDiscountGroupsDetail() {
  const {id} = useParams();

  const [warehouseDictionaryEdit] = usePermissions({
    permissionKeys: ['warehouseDictionaryEdit'],
  });

  const {
    data: supplierDiscountGroup,
    isLoading: isLoadingSupplierDiscountGroup,
    isError: hasSupplierDiscountGroupError,
  } = useGetSupplierDiscountGroupQuery(
    {supplierDiscountGroupId: id as string},
    {skip: isNil(id) || isEmpty(id)}
  );

  const header: SettingsTemplateHeader = {
    title: supplierDiscountGroup?.supplierDiscountGroupCode ?? '',
    breadcrumbs: [
      {
        label: i18n.t('entity.warehouse.labels.supplierDiscounts'),
        href: settingsRoutes.warehousesSupplierDiscountGroups,
      },
    ],
    alerts: !warehouseDictionaryEdit
      ? [
          {
            type: 'banner',
            variant: 'info',
            message: i18n.t('module.warehouse.label.missingWarehouseDictionaryEditPermission'),
          },
        ]
      : undefined,
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.supplierDiscountDetail')} />
      <SettingsTemplate
        header={header}
        isLoading={isLoadingSupplierDiscountGroup}
        isError={hasSupplierDiscountGroupError}
        data-testid={testIds.settings.warehousesSupplierDiscountGroupsDetail('template')}
      >
        <SupplierDiscountGroupDetailForm
          id={id as string}
          supplierDiscountGroup={supplierDiscountGroup}
          data-testid={testIds.settings.warehousesSupplierDiscountGroupsDetail(
            'supplierDiscountGroupDetailForm'
          )}
        />
      </SettingsTemplate>
    </>
  );
}
